import ANALYTICS_DEBUG_MODE from "./analytics-debug-mode";

const DEBUG = ANALYTICS_DEBUG_MODE;

const trackEvent = function (name, params = {}) {
    if (typeof gtag === "function") {

        gtag('event', name, params);

        if (DEBUG) {
            console.log('Event name:', name, {
                name: name,
                params: params,
            });
        }
    }
};

export default class AnalyticsTracker {
    trackContactForm(form) {
        trackEvent('contact_form', {
            contact_form: form,
        });
    }

    trackPurchase(id, value, items) {
        trackEvent('purchase', {
            transaction_id: id,
            currency: 'EUR',
            value: value,
            items: items,
        });
    }

    trackSubscribeToNewsletter() {
        trackEvent('subscribe_to_newsletter', {});
    }

    trackMailClick() {
        trackEvent('mail_click', {});
    }

    trackTelClick() {
        trackEvent('tel_click', {});
    }
}
